export enum TaskPriorityEnum {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  // URGENT = 'urgent',
}

export const TaskPriorityOptions = [
  { label: 'Low', value: TaskPriorityEnum.LOW },
  { label: 'Medium', value: TaskPriorityEnum.MEDIUM },
  { label: 'High', value: TaskPriorityEnum.HIGH },
  // { label: 'Urgent', value: TaskPriorityEnum.URGENT },
];

export const getTaskPriorities = (type: string): string => {
  const option = TaskPriorityOptions.find((option) => option.value === type);
  return option ? option.label : type;
};
